import { Observable } from 'rxjs';
import { RequestOptions } from '@nirvana/shared/microservice-client';
import { BaseWebComponentDataProvider } from '../framework/BaseWebComponentDataProvider';
import { sanitizeObject } from '../utils/sanitization.utils';
import { GetWidgetDataRequest } from '../types/widget/types';
import { getRequestDefaultOptions } from '../utils/request.utils';
import { ReportingPeriod } from '@nirvana/shared/dtos/types/shared/time';

export class BaseWidgetDataProvider<T> extends BaseWebComponentDataProvider {
  constructor(
    private readonly dataFetchMethod: (request: GetWidgetDataRequest, options: RequestOptions) => Observable<T>
  ) {
    super();
  }

  async getValues(params: {
    reportingPeriod: ReportingPeriod;
    widgetId: string;
    dashboardId: string;
    locale: string;
    timezone: string;
    targetIds: Array<string>;
  }): Promise<T> {
    try {
      // increased request timeout to 5 min because of the load of microservice-widgets
      const options = getRequestDefaultOptions();
      options.requestTimeout = 5 * 60000;

      const response = await this.dataFetchMethod(
        {
          reportingPeriod: params.reportingPeriod,
          widgetId: params.widgetId,
          dashboardId: params.dashboardId,
          locale: params.locale,
          timezone: params.timezone,
          targetIds: params.targetIds,
        },
        options
      ).toPromise();
      return sanitizeObject(response) as T;
    } catch (e) {
      throw e;
    }
  }
}
